import axios from 'axios';
import { LaunchDataInfo } from '../types';
import { BACKEND_URL, config } from '../util';

export const createUpcomingToken = async (
  data: Partial<LaunchDataInfo>,
): Promise<any> => {
  try {
    const response = await axios.post(`${BACKEND_URL}/upcoming`, data, config);
    return response.data;
  } catch (err) {
    console.log('error createUpcomingToken: ', err);
    return;
  }
};

export const cancelUpcomingToken = async (data: {
  coinId: string;
  wallet: string;
  signature: string;
  reason: string;
}): Promise<any> => {
  try {
    const response = await axios.post(
      `${BACKEND_URL}/upcoming/cancel`,
      data,
      config,
    );
    return response.data;
  } catch (err) {
    console.log('error cancelUpcomingToken: ', err);
    return;
  }
};

export const getCurrentUpcomingTokenByUser = async (
  userAddress: string,
): Promise<any> => {
  try {
    console.log('userAddress', userAddress);
    const response = await axios.get(
      `${BACKEND_URL}/upcoming/creator/${userAddress}`,
      config,
    );

    console.log('response', response);
    return response.data;
  } catch (err) {
    console.log('error getCurrentUpcomingTokenByUser: ', err);
    return;
  }
};

export const getUpcomingToken = async (idCoin: string): Promise<any> => {
  try {
    const response = await axios.get(
      `${BACKEND_URL}/upcoming/${idCoin}`,
      config,
    );
    return response.data;
  } catch (err) {
    console.log('error getUpcomingToken: ', err);
    return;
  }
};

export const getVotedOfUpcomingToken = async (idCoin: string): Promise<any> => {
  try {
    const response = await axios.get(`${BACKEND_URL}/vote/${idCoin}`, config);

    return response.data;
  } catch (err) {
    console.log('error getVotedOfUpcomingToken: ', err);
    return;
  }
};

export const votedForLaunching = async (data): Promise<any> => {
  try {
    const response = await axios.post(`${BACKEND_URL}/vote`, data, config);

    return response.data;
  } catch (err) {
    console.log('error votedForLaunching: ', err);
    return;
  }
};
